import { form } from '../../formState'
import { useTexts } from './useTexts'

export function Surname() {
  const texts = useTexts()

  return (
    <form.TextField
      name="surname"
      testId="surname"
      label={texts.surname}
      validateOn="blur change"
    />
  )
}
